<template>
  <section class="home-hero">
    <div class="hero-inner g-container">
      <div class="hero-text">
        <span class="eyebrow">数字保函 · 全程线上办理</span>
        <h1 class="hero-title">一站式<br/>电子保函办理平台</h1>
        <p class="hero-sub">专业可靠 · 一键申请 · 最快 3min出函 · 真伪可查</p>
        <div class="hero-cta">
          <button class="g-btn g-btn-primary g-btn-lg" @click="$router.push('/project')">
            立即申请
            <i class="arr"></i>
          </button>
          <button class="g-btn g-btn-default g-btn-lg" @click="$router.push('/search')">
            验真伪
          </button>
        </div>

        <ul class="hero-stats">
          <li>
            <strong>{{ stats.issued }}+</strong>
            <span>累计出函</span>
          </li>
          <li>
            <strong>{{ stats.amount }}亿</strong>
            <span>担保金额</span>
          </li>
          <li>
            <strong>{{ stats.bank }}</strong>
            <span>合作机构</span>
          </li>
          <li>
            <strong>{{ stats.speed }}min</strong>
            <span>最快出函</span>
          </li>
        </ul>
      </div>

      <div class="hero-visual">
        <div class="visual-card">
          <div class="card-bar">
            <span></span><span></span><span></span>
          </div>
          <div class="card-body">
            <div class="card-title">电子投标保函</div>
            <div class="card-meta">
              <div><span>申请编号</span><strong>BH202408001234</strong></div>
              <div><span>担保金额</span><strong class="num">¥ 100,000.00</strong></div>
              <div><span>出函机构</span><strong>余干县干越融资担保有限公司</strong></div>
              <div><span>开函时间</span><strong>2024-08-12 09:36</strong></div>
            </div>
            <div class="card-step">
              <div class="step done"><i></i>资料提交</div>
              <div class="step done"><i></i>机构审核</div>
              <div class="step done"><i></i>出函</div>
            </div>
          </div>
        </div>
        <div class="visual-glow"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeHero',
  data () {
    return {
      stats: { issued: 18650, amount: 42.6, bank: 36, speed: 3 }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.home-hero {
  position: relative;
  background: linear-gradient(180deg, #EFF6FF 0%, #F5F7FA 100%);
  overflow: hidden;
}

.hero-inner {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 48px;
  align-items: center;
  padding: 88px 24px 96px;
}

.hero-text {
  .eyebrow {
    display: inline-block;
    padding: 6px 14px;
    background: #fff;
    border: 1px solid @primary-soft;
    border-radius: @radius-full;
    color: @primary;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 24px;
    box-shadow: @shadow-sm;
  }

  .hero-title {
    font-size: 56px;
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -1px;
    color: @text-strong;
    margin: 0 0 20px;
  }

  .hero-sub {
    font-size: 17px;
    color: @text-secondary;
    margin: 0 0 36px;
    max-width: 480px;
  }

  .hero-cta {
    display: flex;
    gap: 12px;
    margin-bottom: 56px;

    .arr {
      width: 14px;
      height: 14px;
      margin-left: 4px;
      background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'><path d='M5 12h12m-5-5l5 5-5 5' stroke='%23fff' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>") center / contain no-repeat;
    }
  }
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 24px;

  li {
    strong {
      display: block;
      font-size: 26px;
      font-weight: 700;
      color: @text-strong;
      letter-spacing: -.5px;
    }
    span {
      display: block;
      font-size: 13px;
      color: @text-muted;
      margin-top: 4px;
    }
  }
}

.hero-visual {
  position: relative;
  display: flex;
  justify-content: center;
}

.visual-card {
  position: relative;
  width: 460px;
  background: #fff;
  border-radius: @radius-xl;
  box-shadow: @shadow-xl;
  overflow: hidden;
  transform: rotate(-2deg);
  transition: transform @duration-slow @ease-out;

  &:hover { transform: rotate(0) translateY(-6px); }
}

.card-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 20px;
  background: @bg-soft;
  border-bottom: 1px solid @border-light;

  span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #CBD5E1;
    &:nth-child(1) { background: #FF6B6B; }
    &:nth-child(2) { background: #FFC75A; }
    &:nth-child(3) { background: #4ECB71; }
  }
}

.card-body {
  padding: 24px 28px 28px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: @text-strong;
  margin-bottom: 20px;
}

.card-meta {
  div {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    padding: 10px 0;
    border-bottom: 1px dashed @border-light;

    &:last-child { border-bottom: none; }

    span { color: @text-muted; }
    strong { color: @text-strong; font-weight: 600; }
    .num { color: @danger; font-weight: 700; }
  }
}

.card-step {
  display: flex;
  gap: 8px;
  margin-top: 24px;

  .step {
    flex: 1;
    text-align: center;
    font-size: 12px;
    padding: 8px;
    border-radius: @radius-sm;
    background: @bg-soft;
    color: @text-muted;
    position: relative;

    &.done {
      background: @success-soft;
      color: @success;
      i {
        display: inline-block;
        width: 12px;
        height: 12px;
        vertical-align: -2px;
        margin-right: 4px;
        background: @success;
        border-radius: 50%;
        mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'><path d='M5 13l4 4L19 7' stroke='%23fff' stroke-width='3' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>") center / contain no-repeat;
      }
    }
  }
}

.visual-glow {
  position: absolute;
  width: 380px;
  height: 380px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(37, 99, 235, .25), transparent 60%);
  z-index: -1;
  filter: blur(30px);
}
</style>
